import { ThemedView } from "@/components/ThemedView";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useLocale } from "@/hooks/locale";
import { useTheme } from "@/hooks/theme";
import { hexToRgba } from "@/lib/colors";
import type { UseFormReturn } from "react-hook-form";

export const FormTextField = (props: {
    label?: string;
    form: UseFormReturn<any>;
    name: string;
}) => {
    const theme = useTheme();
    const colors = theme.colors;
    const { t } = useLocale();
    const themeVars = {
        "--input-bg": colors.surface,
        "--input-bg-disabled": colors.disabled,
        "--input-bg-readonly": colors.background,
        "--input-text": colors.onSurface,
        "--input-placeholder": colors.onDisabled,
        "--input-border": colors.disabled,
        "--input-border-hover": colors.onDisabled,
        "--input-accent": colors.primary,
        "--input-accent-ring": hexToRgba(colors.primary, 0.18),
        "--input-error": colors.error,
        "--input-error-ring": hexToRgba(colors.error, 0.18),
        "--input-helper": colors.onDisabled,
    } as React.CSSProperties;

    return (
        <>
            <FormField
                control={props.form.control}
                name={props.name}
                render={({ field }) => {
                    return (
                        <FormItem>
                            <FormControl>
                                <ThemedView style={{ gap: "12px" }}>
                                    <FormLabel
                                        style={{
                                            fontWeight: "500",
                                            color: theme.colors.onSurface,
                                        }}
                                    >
                                        {t(props.label ?? "")}
                                    </FormLabel>
                                    <Input
                                        {...field}
                                        className={`pro-input`}
                                        style={{
                                            ...themeVars,
                                        }}
                                    />

                                    <FormMessage
                                        style={{
                                            color: theme.colors.error,
                                            padding: "0px",
                                            margin: "0px",
                                            fontSize: "12px",
                                        }}
                                        className="pro-input-helper"
                                    ></FormMessage>
                                </ThemedView>
                            </FormControl>
                        </FormItem>
                    );
                }}
            ></FormField>
        </>
    );
};
